module.exports = __webpack_public_path__ + "static/img/photo-7.40b055f1.jpg";